var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#FFEEED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0381 29.0832C37.6239 28.4974 37.6239 27.5476 37.0381 26.9619C36.4523 26.3761 35.5026 26.3761 34.9168 26.9618L37.0381 29.0832ZM26.9618 34.9168C26.3761 35.5026 26.3761 36.4523 26.9618 37.0381C27.5476 37.6239 28.4974 37.6239 29.0832 37.0381L26.9618 34.9168ZM34.9168 37.0381C35.5026 37.6239 36.4523 37.6239 37.0381 37.0381C37.6239 36.4523 37.6239 35.5026 37.0381 34.9168L34.9168 37.0381ZM29.0832 26.9618C28.4974 26.3761 27.5476 26.3761 26.9618 26.9618C26.3761 27.5476 26.3761 28.4974 26.9618 29.0832L29.0832 26.9618ZM41.75 32C41.75 37.3847 37.3847 41.75 32 41.75V44.75C39.0416 44.75 44.75 39.0416 44.75 32H41.75ZM32 41.75C26.6152 41.75 22.25 37.3847 22.25 32H19.25C19.25 39.0416 24.9584 44.75 32 44.75V41.75ZM22.25 32C22.25 26.6152 26.6152 22.25 32 22.25V19.25C24.9584 19.25 19.25 24.9584 19.25 32H22.25ZM32 22.25C37.3847 22.25 41.75 26.6152 41.75 32H44.75C44.75 24.9584 39.0416 19.25 32 19.25V22.25ZM34.9168 26.9618L30.9393 30.9393L33.0606 33.0606L37.0381 29.0832L34.9168 26.9618ZM30.9393 30.9393L26.9618 34.9168L29.0832 37.0381L33.0606 33.0606L30.9393 30.9393ZM37.0381 34.9168L33.0606 30.9393L30.9393 33.0606L34.9168 37.0381L37.0381 34.9168ZM33.0606 30.9393L29.0832 26.9618L26.9618 29.0832L30.9393 33.0606L33.0606 30.9393Z",
    fill: "#F96056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/Rejected.160823e0eab5ae0c98eae28b59db4dba.svg";
export { ForwardRef as ReactComponent };